import clsx from 'clsx'
import { ACTION_ICONS } from 'components/MissionsTable/MissionsTable'
import { ReactComponent as SandClockSvg } from 'images/icons/sand_clock.svg'
import { ACTION_TYPE_LABELS, ActionType } from 'utils/servicePointsCatalog'

import style from './ServiceCalibCatalog.module.css'

type ServicePointActionChipsProps = {
  allowedActions: ActionType[]
  selectedActions: ActionType[]
  onActionToggle?: (action: ActionType) => void
  compact?: boolean
}

export function ServicePointActionChips({
  allowedActions,
  selectedActions,
  onActionToggle,
  compact = false,
}: ServicePointActionChipsProps) {
  if (allowedActions.length <= 1) {
    return null
  }

  return (
    <div className={compact ? style.actionChipsCompact : style.actionChips}>
      {allowedActions.map(action => {
        const ActionIcon = ACTION_ICONS[action] || SandClockSvg
        const isSelected = selectedActions.includes(action)
        return (
          <button
            key={action}
            type="button"
            className={style.actionChip}
            data-selected={isSelected}
            disabled={!onActionToggle}
            onClick={event => {
              event.stopPropagation()
              onActionToggle?.(action)
            }}
            title={ACTION_TYPE_LABELS[action] || ActionType[action]}
          >
            <ActionIcon className={clsx(style.themedIcon, style.actionChipIcon)} />
          </button>
        )
      })}
    </div>
  )
}
